
import AppClientHeadingSettings from "@/components/layout-editor/ClientHeadingSettings.vue";
import AppHeadingSettings from "@/components/layout-editor/HeadingSettings.vue";
import { DocumentLayoutClientHeading } from "@/utils/documents/layout-client-heading";
import { DocumentLayoutHeading } from "@/utils/documents/layout-heading";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getReminderLayoutPropSelectGroup } from "@/utils/prop-select/reminder-layout-prop-select-group";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			tab: 0,
			selectedLanguage: "nl-be"
		};
	},
	props: {
		layout: {
			type: Object as ()=>ReminderLayout,
			required: true
		}
	},
	computed: {
		tabs(): string[] {
			return [
				this.$ct("heading"),
				this.$ct("clientAddress"),
			].map(t => t.toString());
		},
		heading():DocumentLayoutHeading{
			return this.layout.Heading;
		},
		clientHeading():DocumentLayoutClientHeading{
			return this.layout.ClientHeading;
		},
		fields():PropSelectGroup{
			return getReminderLayoutPropSelectGroup();
		}
	},
	methods: {
		convertToFreeBlock(){
			let block = this.layout.Heading.toFreeBlock();
			this.layout.FreeBlocks.push(block);
			this.$emit("open-free-block", block);
		},
		convertClientToFreeBlock(heading:DocumentLayoutClientHeading){
			let block = heading.toFreeBlock("Reminder");
			this.layout.FreeBlocks.push(block);
			this.$emit("open-free-block", block);
		}
	},
	components: {
		AppHeadingSettings,
		AppClientHeadingSettings
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	}
});
